import { createRoot } from 'react-dom/client';
import React, { useEffect, useState } from 'react';
import Ciallo from './components/Ciallo';
import Jumper from './components/Jumper';
import './index.css';
// TODO:晚点改成cdn形式
import meguru from './assets/meguru.aac'

const colorMap = [{
    dur: 12,
    color: 'red',
    size: "35px"
}, {
    dur: 15,
    color: 'aqua',
    size: "40px"
}, {
    dur: 11,
    color: 'coral',
    size: "25px"
}, {
    dur: 7,
    color: 'black',
    size: "19px"
}, {
    dur: 10,
    color: 'greenyellow',
    size: "29px"
}, {
    dur: 12,
    color: 'gold',
    size: '18px'
}, {
    dur: 15,
    color: 'orange',
    size: '50px'
}, {
    dur: 11,
    color: 'pink',
    size: '80px'
}, {
    dur: 12,
    color: 'silver',
    size: "45px"
}, {
    dur: 18,
    color: 'cyan',
    size: "29px"
}, {
    dur: 11,
    color: 'greenyellow',
    size: "23px"
}, {
    dur: 14,
    color: 'grey',
    size: "19px"
}, {
    dur: 6,
    color: 'violet',
    size: "45px"
}, {
    dur: 15,
    color: 'blue',
    size: '26px'
}, {
    dur: 14,
    color: 'green',
    size: '50px'
}, {
    dur: 12,
    color: 'aqua',
    size: '75px'
}, {
    dur: 11,
    color: 'black',
    size: "25px"
}]

const audioList = [meguru]

const App = () => {
    const [isMobile, setIsMobile] = useState(false);
    let audioIndex = 0;

    // 检测是否为移动设备
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);

    const randomColor = () => {
        const r = Math.floor(Math.random() * 256)
        const g = Math.floor(Math.random() * 256)
        const b = Math.floor(Math.random() * 256)
        return `rgb(${r},${g},${b})`
    }

    const cialloAppend = (event) => {
        // 获取坐标，兼容触摸事件
        const x = event.pageX || (event.touches && event.touches[0] ? event.touches[0].pageX : 0);
        const y = event.pageY || (event.touches && event.touches[0] ? event.touches[0].pageY : 0);
        
        if (!x || !y) return;
        
        const span = document.createElement('span')
        span.innerHTML = 'Ciallo～(∠・ω< )⌒★';
        
        // 根据设备类型调整字体大小
        const fontSize = isMobile ? '16px' : '20px';
        
        span.style.cssText = `
            position: absolute; 
            left: ${x}px; 
            top: ${y - 20}px; 
            color: ${randomColor()}; 
            font-weight: bold;
            font-size: ${fontSize};
            pointer-events: none;
            z-index: 1000;
            user-select: none;
            -webkit-user-select: none;
        `;
        
        document.body.appendChild(span);
        const animation = span.animate({
            "top": `${y - 180}px`,
            "opacity": 0
        }, {
            duration: 1500,
        });
        
        // 每次点击都新建 Audio 实例，实现连续播放
        try {
            const audio = new window.Audio(audioList[audioIndex]);
            audio.play().catch((error) => {
                console.log('音频播放失败:', error);
            });
            audioIndex = (audioIndex + 1) % audioList.length;
        } catch (error) {
            console.log('音频播放失败:', error);
        }
        
        animation.onfinish = () => {
            span.remove();
        }
    }

    useEffect(() => {
        // 添加点击事件
        document.body.addEventListener('click', cialloAppend);
        
        // 添加触摸事件（移动端）
        document.body.addEventListener('touchstart', cialloAppend, { passive: true });

        return () => {
            document.body.removeEventListener('click', cialloAppend);
            document.body.removeEventListener('touchstart', cialloAppend);
        }
    }, [isMobile])

    // 生成更多条滚动字符，数量提升到50条，分布更密集，dur为4~7秒随机，增加随机 animationDelay
    const N = 50;
    const fastColorMap = Array.from({ length: N }, (_, i) => {
        const dur = 4 + Math.random() * 3; // 4~7秒
        return {
            dur,
            color: colorMap[i % colorMap.length].color,
            size: colorMap[i % colorMap.length].size,
            top: `${Math.random() * 95}vh`, // 随机纵向分布
            delay: `-${Math.random() * dur}s` // 随机负延迟
        };
    });

    return (
        <>
            <Jumper />
            <div style={{ 
                position: 'relative', 
                width: '100vw', 
                height: '100vh',
                overflow: 'hidden'
            }}>
                {fastColorMap.map((item, index) => (
                    <div key={index} style={{ position: 'absolute', left: 0, top: item.top, width: '100vw', pointerEvents: 'none', height: item.size }}>
                        <Ciallo dur={item.dur} color={item.color} size={item.size} delay={item.delay} />
                    </div>
                ))}
            </div>
        </>
    );
}

const domNode = document.getElementById('root');
const root = createRoot(domNode);
root.render(<App />);
